import { useMutation, useQueryClient } from '@tanstack/react-query'
import { productApi } from 'services'
import type { ProductCustomField } from 'services/productApi'
import { useSnackbar } from 'contexts'
import { getErrorMessage } from 'utils'

/**
 * VRG-101 — replace a product's curated custom-fields list
 * ([{key,label,value,order,visible}]).
 */
export const useProductCustomFields = () => {
  const queryClient = useQueryClient()
  const { open: notification } = useSnackbar()

  return useMutation({
    mutationFn: ({
      productId,
      customFields,
    }: {
      productId: string
      customFields: ProductCustomField[]
    }) => productApi.setCustomFields(productId, customFields),
    onSuccess: (product) => {
      queryClient.invalidateQueries({ queryKey: ['product', product.id] })
      queryClient.invalidateQueries({ queryKey: ['products'] })
      notification({ type: 'success', title: 'Custom fields saved' })
    },
    onError: (error: any) => {
      notification({
        type: 'error',
        title: 'Could not save custom fields',
        text: getErrorMessage(error) || 'Failed to update custom fields',
      })
    },
  })
}
